module.exports = __webpack_public_path__ + "static/media/resetSearch.baf8241f.svg";